export default "__VITE_ASSET__BdVtls3p__"